module.exports = __webpack_public_path__ + "img/default-image.0b8b6d00.png";